import i18n from "intl/i18n"
import { Dayjs } from "utils/dayjs"

import Reservation from "models/Reservation"
import UserService from "services/UserService"
import alertModals from "stores/alertModals"
import Text from "components/Text/Text"

interface IHandleInvoiceBlockedErrorParams {
    reservation: Reservation
}

export interface IInvoiceBlockedInfo {
    reason?: string
    date?: Dayjs
    user?: string
}

export async function getInvoiceBlockedInfo({
    reservation,
}: IHandleInvoiceBlockedErrorParams): Promise<IInvoiceBlockedInfo | null> {
    if (!reservation?.pricingDetails?.invoiceBlocked) {
        return null
    }
    const emails = await UserService.getUserEmailsByIds(
        reservation?.pricingDetails?.invoiceBlockedBy
            ? [reservation.pricingDetails.invoiceBlockedBy]
            : []
    )
    const blockedByEmail = reservation?.pricingDetails?.invoiceBlockedBy
        ? emails[reservation.pricingDetails.invoiceBlockedBy]
        : undefined

    return {
        reason: reservation?.pricingDetails?.invoiceBlockedReason,
        date: reservation?.pricingDetails?.invoiceBlockedDate,
        user: blockedByEmail,
    }
}

export async function handleInvoiceBlockedError({
    reservation,
}: IHandleInvoiceBlockedErrorParams) {
    const invoiceBlockedInfo = await getInvoiceBlockedInfo({ reservation })
    alertModals.show({
        title: i18n.t('common.attention'),
        buttonLabel: i18n.t('common.ok'),
        theme: "secondary",
        children: <>
            {i18n.t('invoiceDrafts.errorToast.invoiceBlocked')}
            {!!invoiceBlockedInfo &&
                <div className="mt-4">
                    {!!invoiceBlockedInfo.reason &&
                        <>
                            <div className="font-bold">{i18n.t('reservation.reason')}</div>
                            <div className="mt-half">{invoiceBlockedInfo.reason}</div>
                        </>
                    }
                    {!!invoiceBlockedInfo.user && !!invoiceBlockedInfo.date &&
                        <Text type="pSmallest" className="color-grey-500 mt-half">
                            {i18n.t('common.dateByUser', {
                                date: invoiceBlockedInfo.date.format(i18n.t('config.dateLongTimeFormat')),
                                user: invoiceBlockedInfo.user,
                            })}
                        </Text>
                    }
                </div>
            }
        </>,
        maxWidth: "586px",
    })
}
